import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter-primary",
  "use": "filter-primary-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"filter-primary\">\n    <path fill=\"#1d378c\" d=\"M4.59 6.102c2.141 2.75 5.307 6.821 5.307 6.821v4.615c0 1.016.831 1.847 1.847 1.847 1.015 0 1.846-.831 1.846-1.847v-4.615l5.307-6.821c.471-.61.037-1.487-.738-1.487H5.319c-.766 0-1.2.877-.73 1.487z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol